<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M14.1667 7.91602V10.7493C14.1667 11.2161 14.1667 11.4494 14.0758 11.6277C13.9959 11.7845 13.8685 11.912 13.7117 11.9919C13.5334 12.0827 13.3 12.0827 12.8333 12.0827L2.5 12.0827M10.8333 12.0827V14.916C10.8333 15.3827 10.8333 15.6161 10.7425 15.7943C10.6626 15.9511 10.5351 16.0786 10.3783 16.1585C10.2001 16.2493 9.96671 16.2493 9.5 16.2493H2.5M2.5 1.66602L2.5 18.3327M2.5 7.91601L16.1667 7.91602C16.6334 7.91602 16.8667 7.91602 17.045 7.82519C17.2018 7.74529 17.3293 7.61781 17.4092 7.46101C17.5 7.28275 17.5 7.04939 17.5 6.58268V5.08268C17.5 4.61597 17.5 4.38262 17.4092 4.20436C17.3293 4.04756 17.2018 3.92007 17.045 3.84018C16.8667 3.74935 16.6334 3.74935 16.1667 3.74935L2.5 3.74935L2.5 7.91601Z"
      stroke="white"
      stroke-width="1.67"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
